// tslint:disable: max-line-length
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { DwSectionBaseComponent, DwComponentSectionPreference, DwComponentType, DwComponent, DwSelectLookupComponent, DwExpressionService, 
         DwUiConfigRegistryService, DwUIMetaDataConfigToken, DwUIMetaDataConfig, DwMetaDataServiceToken, DwMetaDataService, DwMessagingService, 
         DwQueryHelper, DwQueryFilter, DwOperator, DwFilterType, DwOrmDataServiceToken, DwOrmDataService, DwSecurityUserService, DwFormContextMode, 
         DwLookupInfo, DwLookupInfoAttribute, DwAttributeType } from '@devwareapps/devware-cap';
import { TemplateEntity, AppMetaDataLookups, RequestEntity, AppMetaDataService, CompanyEntity, EthosUserEntity, RoEthosUserEntity } from 'src/app/meta-data/app-meta-data.service';
import { WachterUserExt } from 'src/app/shared/models/wachter-user.model';
import { EquipRequestService } from '../../services/equip-request.service';

@DwComponent({
  key: 'Templates',
  name: 'Templates',
  parentItemName: 'Request',
  componentType: DwComponentType.formSection,
})
@Component({
  selector: 'app-equip-template-section',
  template: `

  <div *ngIf="!showAddTemplate">
    <dw-search-select-lookup #templateLookup [lookupId]="templateLookupId" 
      [(ngModel)]="selectedTemplateId"></dw-search-select-lookup>

    <button class="btn btn-success m-2" (click)="applyTemplate()">Apply</button>
    <button class="btn btn-success m-2" (click)="showCreateTemplate()">Create Template</button>
 </div>

 <div *ngIf="showAddTemplate">
    <h2>Create Template</h2>

    <div dwRow>
      <div dwCol="12">
        <label>Template Name</label>
        <input type="text" class="form-control" [(ngModel)]="templateName">
      </div>
    </div>

    <button class="btn btn-success m-2" (click)="saveTemplate()">Save</button>
    <button class="btn btn-success m-2" (click)="closeCreateTemplate()">Cancel</button>
 </div>`
})
//[(overrideValues)]="newValues"
export class EquipTemplateSectionComponent extends DwSectionBaseComponent<DwComponentSectionPreference>
  implements OnInit {
  selectedTemplateId: number;
  showAddTemplate = false;
  templateName: string;
  //newValues: any;  
  templateLookupId = AppMetaDataLookups.TemplateActiveItems;

  private ignoreCompanyChange = false;

  @ViewChild('templateLookup') templateSelect: DwSelectLookupComponent;

  constructor(
    dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
    private messageService:  DwMessagingService,
    private securityService: DwSecurityUserService,
    private equipRequestService: EquipRequestService) {
      super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
    }

    ngOnInit() {
      super.ngOnInit();

      setTimeout(() => {
        this.setupCompanyChange()
        if (!this.formGroup || !this.formConfig){
          return;
        }
        if (this.formConfig.formMode == DwFormContextMode.add) {
        this.addSignature(this.getUserControl())
        }
      }, 100);
    }

    setupCompanyChange() {
      this.formGroup.get('CompanyId').valueChanges
        .subscribe(value => {
          this.handleCompanyChange(value);
        });
    }

    handleCompanyChange(companyId: number) {
      if (this.ignoreCompanyChange) {
        return;
      }

      this.equipRequestService.getEquipmentCompany(companyId)
        .subscribe(company => {
          this.updateCompanyInfo(company);
        });
    }

  updateCompanyInfo(company: CompanyEntity) {
    if (!company) {
      return;
    }

    const requestUpdate: Partial<RequestEntity> = {
       AcountNumber: company.AcctNumber,
       CompanyEmail: company.Email
    };

    this.formGroup.patchValue(requestUpdate);
  }

  applyTemplate() {
    const request = this.getTemplateRequest(this.selectedTemplateId);


    this.updateFormValue(request);
  }

  showCreateTemplate() {
    this.templateName = 'New Template';
    this.showAddTemplate = true;
  }

  saveTemplate() {
    const request: RequestEntity = this.formGroup.value;
    request.RequestEquipment.forEach(x => {
      x.RequestId = null;
      x.RequestEquipmentId = null;
    })
    request.RequestId = null;
    this.equipRequestService.createTemplate(this.templateName, request)
      .subscribe(result => {
          if (this.templateSelect.lookupItems){
            const json = JSON.stringify(JSON.stringify(result.SettingsJson));
            const newTemplate : DwLookupInfo = { 
              'Id': result.TemplateId.toString(), 
              'Display' : result.Name, 
              'SettingsJson' : json,
              'Attributes' : [ { 'AttrName' : 'SettingsJson', 'Value' : json, 'AttrType' : DwAttributeType.JSON }]
            };
            this.templateSelect.lookupItems.unshift(newTemplate);
            this.selectedTemplateId = result.TemplateId;
          }
          this.messageService.showMessage({
            messageHeading: `Template created`,
            messageBody: `Template ${this.templateName} has been created`});
      });

      this.closeCreateTemplate();
  }

  private closeCreateTemplate() {
    this.showAddTemplate = false;
  }


  private getTemplateRequest(templateId: number): RequestEntity {
    const template: any = this.templateSelect.allLookupItems.find(li => li.Id === templateId.toString());

    if (template && template.SettingsJson) {
      try {
        // Previous format to parse data = double parsing
        var result = JSON.parse(template.SettingsJson);
        return JSON.parse(result);
      } catch (error) {
        console.warn(`Could not parse JSON for template ${template.Display}`);
      }
      // Current format to parse data
      try {
        var resultTwo = result;
        return resultTwo;
      } catch (error) {
        console.warn(`Could not parse JSON for template ${template.Display}`);
      }
    }

    return;
  }

  private addSignature(userId: number){
    this.getUser(userId).subscribe(result => {
      const user: RoEthosUserEntity = result[0];
      const formValue: RequestEntity = this.formGroup.value
      formValue.RequesterNameAndNumber = user.NameFirstPreferedLast + '\r\n' + user.OfficePhone;
      this.updateFormValue(formValue);
    })
  }

  private getUserControl(){

      const wachterUser = new WachterUserExt(this.securityService.securityContext.AuthenticatedUser);

      return wachterUser.trustUserId;

  }

  private getUser(userId: number){
    const md = new AppMetaDataService();
    const qh = new DwQueryHelper();

    const query = md.RoEthosUser.CreateQuery();
    const queryFilter : DwQueryFilter = new DwQueryFilter();
    queryFilter.Op = DwOperator.And;
    queryFilter.Type = DwFilterType.Equal;
    queryFilter.Value = userId.toString();
    queryFilter.Attr = md.RoEthosUser.UserId;
    query.AddFilterAnd(queryFilter)

    return this.dataService.executeQuery(query)
  }

  private updateFormValue(newRequest: RequestEntity) {
    this.ignoreCompanyChange = true;

     // Note: Using a null RequestEquipementId causes issues on edit since it needs to be unique.  Using -100 since the in memory data source strts at -1 and we don't want them to conflict
     let nextKey = -100;
     newRequest.RequestId = null;
     newRequest.RequestEquipment.forEach(x => {
 
       x.RequestId = null;
       x.RequestEquipmentId = nextKey;
 
       nextKey--;
     });
 

    const mergedValue = { ...this.formGroup.value, ...newRequest };

    this.formGroup.patchValue(mergedValue);

    // Re-enable Company Change logic
    this.ignoreCompanyChange = false;
  }
}
